/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const HomeLink = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 27 23" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M27 11.62L13.83.22.17 11.6l1.46 1.76 2.62-2.18v11.73h2.29V9.27l7.26-6.05 7.05 6.1v11.39h-6.7V14.9h2.87l-2-2.55-2-2.56-2 2.56-2 2.55h2.84V23h11.28V11.31l2.36 2.04z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

HomeLink.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

HomeLink.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default HomeLink;
